<template>
  <div class="flex-center">
    <v-btn color="admin" dark outlined @click="onExport">
      <v-icon left>mdi-file-excel-outline</v-icon>Xuất Excel
    </v-btn>
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import * as XLSX from 'xlsx'
import {saveAs} from 'file-saver'
import {get} from 'lodash'
import moment from 'moment'
import utils from '@/plugins/utils'
import {TYPES} from './helpers'

export default {
  computed: {...mapGetters({banks: 'transaction/banks'})},
  methods: {
    ...mapActions({fetchItemsIndependent: 'transaction/fetchItemsIndependent'}),
    async onExport() {
      this.$loading.active = true
      const items = await this.fetchItemsIndependent({_limit: 0})
      const worksheet = XLSX.utils.json_to_sheet(
        items.map(i => ({
          'Loại giao dịch': this.getType(i.type),
          'Chi tiết giao dịch (10)': i.type === 'exam' ? 'Kỳ ' + get(i, 'data', []).join(',') : '',
          'Trạng thái': this.getStatus(i.status),
          'Mã tài khoản': i.transactionCode,
          'Số tiền nhận': this.getTransactionAmount(i.transactionAmount),
          'Mã tham chiếu giao dịch': i.transactionId,
          'Ghi nhận lúc': this.getTransactionTime(i.transactionTime),
          'Tạo mã lúc': this.getTransactionTime(i.createdAt),
          'Tài khoản tạo': i.userPhone,
          'Hồ sơ đính kèm': i.type !== 'cv6' && i.type !== 'cv10' ? get(i, 'cv.code') : get(i, 'activeCode.code'),
          'Ngân hàng nguồn': this.getBankname(get(i, 'transactionData.sendBankId', '')),
          'Số tài khoản ngân hàng nguồn': get(i, 'transactionData.sendAcctId', '-'),
          'Tên tài khoản ngân hàng nguồnk': get(i, 'transactionData.sendAcctName', '-'),
        })),
      )
      const workbook = {Sheets: {data: worksheet}, SheetNames: ['data']}
      const excelBuffer = XLSX.write(workbook, {bookType: 'xlsx', type: 'array'})
      const data = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
      })
      saveAs(data, 'ds-khoan-thu.xlsx')
      this.$loading.active = false
    },
    getTransactionTime: transactionTime => (!transactionTime ? '' : moment(transactionTime).format('DD/MM/YYYY HH:mm')),
    getTransactionAmount: amount => utils.formatMoney(amount),
    getType: type => {
      const transType = TYPES.find(i => i.value === type)
      return get(transType, 'title', '')
    },
    getStatus: status => {
      switch (status) {
        case 'pending':
          return 'Chưa thanh toán'
        case 'success':
          return 'Đã thanh toán'
        case 'canceled':
          return 'Đã huỷ'
        default:
          return ''
      }
    },
    getBankname(id) {
      if (typeof id === 'string' && id.length) {
        let found = this.banks.find(i => i.bin === id)
        if (!found) found = this.banks.find(i => i.swift_code === id)
        if (found) return `${get(found, 'name', '')} (${get(found, 'shortName', '')})`
        return id
      }
      return '-'
    },
  },
}
</script>
